import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { blogPosts } from "../pages/blog/data/blogPosts";
import BlogTemplate from "../components/BlogTemplate";
import NotFound from "./NotFound";


export default function DynamicBlog() {
  const { slug } = useParams();
  const postMeta = blogPosts.find((post) => post.slug === slug);

  const [content, setContent] = useState(null);

  useEffect(() => {
    if (postMeta?.importPath) {
      postMeta.importPath().then((mod) => {
        setContent(mod.default);
      });
    }
  }, [slug]);

  if (!postMeta) {
    return NotFound();
  }

  if (!content) {
    return <p></p>;
  }

  return (
    <BlogTemplate
      slug={postMeta.slug}
      title={postMeta.title}
      date={postMeta.date}
      topic={postMeta.topic}
      subheading={postMeta.subheading}
      seo_description={postMeta.seo_description}
      image={postMeta.image}
      readingTime={postMeta.readingTime}
      content={content}
    />
  );
}
